import { Icon, getSvgIcon } from '@helpers/icons';
import { FocusRing } from '@react-aria/focus';
import * as React from 'react';
import { useModal } from '../Context/Context';
import S from './Close.styles';
const Close = () => {
    const modal = useModal();
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Button, { type: "button", "aria-label": "Close", onClick: (event) => {
                event.preventDefault();
                modal.onClose();
            }, initial: { opacity: 0 }, animate: { opacity: 1, transition: { delay: 1.2 } }, exit: { opacity: 0 } }, getSvgIcon(Icon.CrossClose))));
};
export default Close;
